var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social social-box"},[_c('div',{class:_vm.className},[_c('i',{staticClass:"fa fa-dollar"}),_c('h3',{on:{"click":_vm.showDetail}},[_vm._v(_vm._s(_vm.balance))]),_c('span',[_vm._v(_vm._s(_vm.accountName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }